<template>
  <div class="page">
    <div class="preview-title">{{data.examTitle}}</div>
    <el-form label-width="120px">
      <el-row type="flex" justify="space-between">
        <el-col :span="4">
          <el-form-item label="参考总分">{{data.totalScores || 0}}分</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="出卷人">{{data.author && data.author.nickname}}</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="参考时间">{{data.time || 0}}分钟</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div class="preview-title sub">剩余考试时间：{{restTime}}秒</div>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4">
          <div
            v-for="(item,index) in data.questionList"
            :key="index"
            style="margin-bottom:10px;border-bottom:1px solid #eee"
          >
            <el-form-item label="Question:"><pre>{{item.question}}</pre></el-form-item>
            <template v-if="item.questionType == 1 || item.questionType == 2">
              <el-form-item
                label="Option:"
                v-for="(_item,index) in item.options"
                :key="index"
              >
                  <el-radio v-model="item.answer" :label="_item"></el-radio>
              </el-form-item>
            </template>
            <template v-if="item.questionType == 3">
                <el-checkbox-group v-model="item.checkList">
                  <el-form-item
                    label="Option:"
                    v-for="(_item,index) in item.options"
                    :key="index"
                  >
                    <el-checkbox :label="_item"></el-checkbox>
                </el-form-item>
                </el-checkbox-group>
            </template>
            <el-form-item label="Your Answer:">
              <template v-if="item.questionType == 1 || item.questionType == 2">
                <el-input type="text" disabled v-model="item.answer"/>
              </template>
              <template v-else-if="item.questionType == 3">
                <el-input type="text" disabled v-model="item.answer=item.checkList.join(',')"/>
              </template>
              <template v-else>
                <el-input
                v-model="item.answer"
                type="textarea"
                rows="5"
                placeholder="input your answer"
              ></el-input>
              </template>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="参考得分">{{item.score}}分</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参考时间">{{item.time}}分钟</el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row style="text-align: center">
        <el-button type="primary" :disabled="loading || restTime==0" @click="saveExercise">提交试卷</el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import utils from "@/utils/index";
export default {
  data() {
    return {
      data: {},
      restTime: 0,
      loading: false,
      done:false,
      checkList:[]
    };
  },
  mounted() {
    utils.ajax.call(
      this,
      "/getExercise",
      { examId: this.$route.query.examId },
      (data, err) => {
        const _questionList = data.questionList.map(item=>{
          return {
            ...item,
            checkList:[]
          }
        })
        data.questionList = _questionList;
        this.data = data;
        this.restTime = parseInt(data.time * 60);
        this.countDown();
      }
    );
  },
  beforeRouteLeave(to, from, next) {
    this.$confirm('确认离开，将会自动提交当前试卷？').then(()=>{
      this.postData();
      next(true);
    }).catch(error=>{
      next(false);
    })
  },
  methods: {
    countDown(it) {
      var interval = setInterval(() => {
        if (this.restTime > 0) {
          this.restTime--;
        } else {
          clearInterval(interval);
          this.postData();
        }
      }, 1000);
    },
    async saveExercise() {
      try {
        await this.$confirm("确认提交试卷？");
        this.postData();
      } catch (error) {}
    },
    postData() {
      if(this.done){
        return;
      }
      utils.ajax.call(
        this,
        "/saveExercise",
        { ...this.$route.query, questionList: this.data.questionList },
        (data, err) => {
          if (!err) {
            this.done = true;
            this.$message.success("答题完成！请耐心等耐阅卷人评分。");
            this.$router.push("/exam/record");
          }
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
</style>
